import {
  getForumPosts,
  createForumPost,
  updateForumPost,
  likeForumPost,
  addComment,
  getForumPostComments,
  getForumPostDetails,
  likeForumPostComment,
  updateForumPostComment,
  deleteForumPostComment,
  deleteForumPost,
  getSubjectsFromFirebase
} from './firebase';

export function getForumPostsAction(timestamp, postArray) {
  let post = postArray;
  return dispatch => {
    dispatch({
      type: 'GET_FORUM_POSTS'
    });
    getForumPosts(timestamp)
      .then(posts => {
        if (!posts) {
          posts = [];
        }
        if (post) {
          post = { ...posts, ...post };
        } else {
          post = { ...posts };
        }
        dispatch({
          type: 'GET_FORUM_POSTS_SUCCESS',
          payload: post
        });
      })

      .catch(e => {
        console.log(e);
        dispatch({ type: 'GET_FORUM_POSTS_ERROR' });
      });
  };
}

export function addForumPostAction(forum) {
  return dispatch => {
    createForumPost(forum)
      .then(f => {
        dispatch({
          type: 'CREATE_FORUM_POST_SUCCESS',
          payload: { ...f }
        });
      })
      .catch(e => {
        console.log(e);
        dispatch({ type: 'CREATE_FORUM_POST_ERROR' });
      });
  };
}

export function getSubjects() {
  return dispatch => {
    getSubjectsFromFirebase(f => {
      dispatch({
        type: 'GET_SUBJECTS_SUCCESS',
        payload: f
      });
    });
  };
}

export function updateForumPostAction(forum) {
  return dispatch => {
    updateForumPost(forum)
      .then(val => {
        dispatch({ type: 'UPDATE_FORUM_POST_SUCCESS', payload: forum });
        return val;
      })
      .catch(e => {
        dispatch({ type: 'UPDATE_FORUM_POST_ERROR' });
        return e;
      });
  };
}

export function likePostAction(forum, uid) {
  return dispatch => {
    let updatedForum = { ...forum };
    if (!updatedForum.upVotes) {
      updatedForum.upVotes = [uid];
    } else if (!updatedForum.upVotes.includes(uid)) {
      updatedForum.upVotes.push(uid);
    } else if (updatedForum.upVotes.includes(uid)) {
      updatedForum.upVotes = updatedForum.upVotes.filter(uv => uv !== uid);
    }
    dispatch({
      type: 'UPDATE_FORUM_POST_SUCCESS',
      payload: { ...updatedForum }
    });
    likeForumPost(forum.key).catch(e => {
      console.log(e);
      dispatch({
        type: 'UPDATE_FORUM_POST_SUCCESS',
        payload: { ...forum }
      });
    });
  };
}
export function setCurrentPostAction(post) {
  return dispatch => {
    dispatch({ type: 'GET_POST', payload: post });
  };
}

export function getCurrentPostAction(key, history, fallback) {
  return dispatch => {
    getForumPostDetails(key)
      .then(data => {
        dispatch({ type: 'GET_POST', payload: data });
        if (!data || Object.entries(data).length === 0) {
          history.push(fallback);
        }
      })
      .catch(e => {
        history.push(fallback);
        console.log(e);
      });
  };
}

export function getForumPostCommentsAction(key) {
  return dispatch => {
    getForumPostComments(key).then(data => {
      dispatch({ type: 'GET_COMMENTS', payload: data || {} });
    });
  };
}

export function addCommentToForumPostAction(comment) {
  return dispatch => {
    addComment(comment)
      .then(_ => {
        dispatch({
          type: 'ADD_COMMENT_SUCCESS',
          payload: comment
        });
        return _;
      })
      .catch(e => {
        dispatch({
          type: 'ADD_COMMENT_ERROR'
        });
      });
  };
}

export function likePostCommentAction(comm, uid) {
  let comment = { ...comm };
  return dispatch => {
    if (comment.upVotes) {
      if (comment.upVotes.includes(uid)) {
        comment.upVotes = comment.upVotes.filter(uv => uv !== uid);
      } else {
        comment.upVotes.push(uid);
      }
    } else {
      comment.upVotes = [uid];
    }
    dispatch({ type: 'UPDATE_COMMENT', payload: { ...comment } });
    likeForumPostComment(comment).catch(e => {
      dispatch({ type: 'UPDATE_COMMENT', payload: { ...comm } });
    });
  };
}

export function editPostCommentAction(comment) {
  return dispatch => {
    updateForumPostComment(comment)
      .then(_ => {
        dispatch({ type: 'UPDATE_COMMENT', payload: { ...comment } });
      })
      .catch(e => {
        console.log(e);
      });
  };
}

export function deletePostCommentAction(comment) {
  return dispatch => {
    dispatch({ type: 'DELETE_COMMENT', payload: comment.key });
    deleteForumPostComment(comment)
      .then(_ => {
        return _;
      })
      .catch(e => {
        dispatch({ type: 'ADD_COMMENT_SUCCESS', payload: { ...comment } });
      });
  };
}

export function deleteForumPostAction(post) {
  return dispatch => {
    deleteForumPost(post.key)
      .then(_ => {
        dispatch({ type: 'DELETE_FORUM_POST_SUCCESS', payload: post.key });
      })
      .catch(e => {
        console.log(e);
      });
  };
}
